import { FC } from 'react';
import { Link } from 'react-router-dom';
import { PiInfoDuotone } from 'react-icons/pi';

interface OnboardingToastProps {
  hasComplete?: boolean | null;
  hasOtherToast?: boolean;
}

const OnboardingToast: FC<OnboardingToastProps> = ({
  hasComplete = false,
  hasOtherToast,
}) => {
  if (hasComplete || hasComplete === null) return null;

  return (
    <div
      className={`sticky left-0 z-10 mx-auto ${
        hasOtherToast ? 'bottom-20' : 'bottom-2'
      }`}
    >
      <div className="mx-6 mt-4 flex flex-wrap items-center gap-2 gap-y-3 rounded-md border border-primary bg-blue-50 px-5 py-3 text-primary">
        <PiInfoDuotone className="h-6 w-6 flex-none" aria-hidden="true" />

        <span className="pr-3 text-lg font-bold">Complete onboarding</span>

        <div className="flex-1 text-center">
          <Link
            to="/onboarding"
            className="inline-block whitespace-nowrap rounded-md bg-primary px-4 py-2 leading-none text-white transition-all hover:bg-primary-dark"
          >
            Start
          </Link>
        </div>
      </div>
    </div>
  );
};

export default OnboardingToast;
